module.exports = __webpack_public_path__ + "static/media/send_vault.2afaa5a4.svg";